// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicMyHomeV1GetThinClientInfoRequest,
  TPublicMyHomeV1GetThinClientInfoModel,
  IMappers,
  TPublicMyHomeV1GetThinClientInfoResponse,
  IPublicMyHomeV1GetThinClientInfoResponse,
  IPublicMyHomeV1GetThinClientInfoResponseError,
} from './types';

export const defaultConfig: TPublicMyHomeV1GetThinClientInfoModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/my-home/v1/get-thin-client-info/',
} as TPublicMyHomeV1GetThinClientInfoModel;

export function createPublicMyHomeV1GetThinClientInfoModel(
  parameters: IPublicMyHomeV1GetThinClientInfoRequest,
): TPublicMyHomeV1GetThinClientInfoModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicMyHomeV1GetThinClientInfoOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicMyHomeV1GetThinClientInfoRequest;
}

export async function fetchPublicMyHomeV1GetThinClientInfo<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicMyHomeV1GetThinClientInfoOptions<TResponse200, TResponse400>): Promise<
  TPublicMyHomeV1GetThinClientInfoResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicMyHomeV1GetThinClientInfoModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicMyHomeV1GetThinClientInfoResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicMyHomeV1GetThinClientInfoResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicMyHomeV1GetThinClientInfoResponse;
}
